/**
 * @generated SignedSource<<82a237b560f180a57f3445cef2e34296>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapSlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapUsersCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapUsersCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapUsersFilters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "usersMapSlug",
    "variableName": "usersMapSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "usersMapUsersCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "usersMapUsersFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "usersMapUsersCount"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterElementsOutOnInitialize",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersMapDetailsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UsersMap",
        "kind": "LinkedField",
        "name": "usersMap",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UsersMapDetails_usersMap"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersMapDetailsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UsersMap",
        "kind": "LinkedField",
        "name": "usersMap",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "UsersMapUserConnection",
            "kind": "LinkedField",
            "name": "usersMapUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UsersMapUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UsersMapUser",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UsersGroupUser",
                            "kind": "LinkedField",
                            "name": "groups",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UsersGroup",
                                "kind": "LinkedField",
                                "name": "usersGroup",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "backgroundColor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fontColor",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avatarUrl",
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isAdmin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "additionalViewerFields",
                                "storageKey": null
                              }
                            ],
                            "type": "Viewer",
                            "abstractKey": "__isViewer"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapUserProfilePublicField",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "filters": [
              "filters"
            ],
            "handle": "connection",
            "key": "MapUsersList_usersMapUsers",
            "kind": "LinkedHandle",
            "name": "usersMapUsers"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MapFilterList",
                "kind": "LinkedField",
                "name": "filterLists",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "filters",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isMapFilterBase"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "allowSelectingMultipleTaxonomies",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MapTaxonomy",
                            "kind": "LinkedField",
                            "name": "mapTaxonomies",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasChildren",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MapTaxonomy",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapTaxonomy",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MapFilterTaxonomy",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "allowSelectingMultipleElements",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "mapElements",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v2/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MapFilterElement",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MapFilterUserField",
                            "kind": "LinkedField",
                            "name": "userFields",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MapFilterUserFieldOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MapFilterUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Map",
            "abstractKey": "__isMap"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21b8adb3b12a2ce4697cf32abce80a90",
    "id": null,
    "metadata": {},
    "name": "UsersMapDetailsManagerQuery",
    "operationKind": "query",
    "text": "query UsersMapDetailsManagerQuery(\n  $usersMapSlug: ID!\n  $usersMapUsersCount: Int!\n  $usersMapUsersCursor: String\n  $usersMapUsersFilters: UsersFiltersInput\n) {\n  usersMap(usersMapSlug: $usersMapSlug) {\n    ...UsersMapDetails_usersMap\n    id\n  }\n}\n\nfragment MapFilterElement_filter on MapFilterElement {\n  id\n  name\n  filterElementsOutOnInitialize\n  allowSelectingMultipleElements\n  mapElements {\n    __typename\n    id\n    name\n  }\n}\n\nfragment MapFilterList_filterList on MapFilterList {\n  filters {\n    __typename\n    id\n    ...MapFilter_filter\n  }\n}\n\nfragment MapFilterTaxonomyFilterWithChildren_mapTaxonomy on MapTaxonomy {\n  id\n  ...MapFilterTaxonomySelector_mapTaxonomy\n  children {\n    id\n    ...MapFilterTaxonomySelector_mapTaxonomy\n  }\n}\n\nfragment MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy on MapTaxonomy {\n  id\n  ...MapFilterTaxonomySelector_mapTaxonomy\n}\n\nfragment MapFilterTaxonomySelector_mapTaxonomy on MapTaxonomy {\n  id\n  name\n  iconUrl\n  children {\n    id\n  }\n}\n\nfragment MapFilterTaxonomy_filter on MapFilterTaxonomy {\n  id\n  allowSelectingMultipleTaxonomies\n  filterElementsOutOnInitialize\n  mapTaxonomies {\n    id\n    hasChildren\n    children {\n      id\n    }\n    ...MapFilterTaxonomyFilterWithChildren_mapTaxonomy\n    ...MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy\n  }\n}\n\nfragment MapFilterUserFieldSelect_userField on MapFilterUserField {\n  id\n  name\n  options {\n    id\n    name\n  }\n}\n\nfragment MapFilterUser_filter on MapFilterUser {\n  id\n  userFields {\n    id\n    ...MapFilterUserFieldSelect_userField\n  }\n}\n\nfragment MapFilter_filter on MapFilterBase {\n  __isMapFilterBase: __typename\n  __typename\n  ...MapFilterTaxonomy_filter\n  ...MapFilterElement_filter\n  ...MapFilterUser_filter\n}\n\nfragment MapFilters_map on Map {\n  __isMap: __typename\n  filterLists {\n    id\n    ...MapFilterList_filterList\n  }\n}\n\nfragment MapUsersListUser_usersMapUser on UsersMapUser {\n  user {\n    id\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    ...UserGroups_user\n  }\n  profileFields {\n    id\n    name\n    value\n  }\n}\n\nfragment MapUsersList_usersMap on UsersMap {\n  id\n  usersMapUsers(first: $usersMapUsersCount, after: $usersMapUsersCursor, filters: $usersMapUsersFilters) {\n    edges {\n      node {\n        id\n        user {\n          id\n        }\n        ...MapUsersListUser_usersMapUser\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n\nfragment UserGroups_user on User {\n  groups {\n    id\n    statusName\n    usersGroup {\n      name\n      backgroundColor\n      fontColor\n      id\n    }\n  }\n}\n\nfragment UsersMapDetails_usersMap on UsersMap {\n  ...MapFilters_map\n  ...MapUsersList_usersMap\n}\n"
  }
};
})();

node.hash = "e4fa391c89f33a37db11af29dd193caf";

module.exports = node;
